import React from 'react';
import CarouselFader from "../components/Home/CarouselFader";
import HomeContent from "../components/Home/HomeContent";
import TestimonialSlider from "../components/Home/TestimonialSlider";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../utils/utils";

export const HomePage = () => {

    return (
        <>
            <Helmet>
                <title>The Friends of Queen's Wood</title>
                <meta name="description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="The Friends of Queen's Wood" />
                <meta property="og:description" content="The Friends of Queen's Wood is a group of volunteers that help look after the wood" />
                <meta property="og:url" content={`${window.location.origin}`} />
                <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
                <meta name="twitter:title" content="The Friends of Queen\'s Wood" />
                <meta name="twitter:description" content="The Friends of Queen\'s Wood is a group of volunteers that help look after the wood" />
                <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
            </Helmet>
            <CarouselFader />
            <HomeContent />
            <TestimonialSlider />
        </>
    )
}
